import AdminMainContainer from '../../../../layouts/admin/AdminMainContainer'
import { DataGrid } from '@mui/x-data-grid'
import useAdminLeaveRequestsUnrespondedPageViewModel, { scopeNamePrefix } from './viewModel'
import { Alert, Box, Button, ButtonGroup, Stack } from '@mui/material'
import adminLeaveRequestsUnrespondedPageStore from '../../../../store/adminLeaveRequestsUnrespondedPageStore'
import RefreshIcon from '@mui/icons-material/Refresh'
import constants from '../../../../constants'
import ApprovalPopup from '../components/ApprovalPopup'

export default function AdminLeaveRequestsUnrespondedPage() {
  const viewModel = useAdminLeaveRequestsUnrespondedPageViewModel()

  return (
    <AdminMainContainer title='Leave Requests (Unresponded)'>
      <Stack direction={'row'} gap={2} flexWrap={'wrap'} sx={{ mb: 2 }}>
        <ButtonGroup>
          {viewModel.sourceTabs.map((tabItem, index) => (
            <Button
              key={`${scopeNamePrefix}-tab-${index}`}
              disabled={viewModel.dataFetchStatus.isLoading}
              loading={viewModel.dataFetchStatus.isLoading && tabItem.value === viewModel.selectedSourceTab}
              variant={tabItem.value === viewModel.selectedSourceTab ? 'contained' : 'outlined'}
              onClick={() => adminLeaveRequestsUnrespondedPageStore.setState({ selectedSourceTab: tabItem.value })}
            >
              {tabItem.label}
            </Button>
          ))}
        </ButtonGroup>
        <Alert
          severity='info'
          action={
            <Button
              color='inherit'
              size='small'
              startIcon={<RefreshIcon />}
              onClick={() => viewModel.fetchLeaveRequestsUnrespondedData()}
            >
              Refresh
            </Button>
          }
          sx={{ flexGrow: 1 }}
        >{`This page only showing latest ${constants.limits.fetchDataCount.sm} data.`}</Alert>
      </Stack>
      <Box sx={{ maxWidth: '100%' }}>
        <DataGrid
          showToolbar
          density='compact'
          columns={viewModel.tableData.columns}
          rows={viewModel.tableData.rows}
          loading={viewModel.dataFetchStatus.isLoading}
        />
      </Box>

      <ApprovalPopup onConfirm={viewModel.onApprovalPopupConfirm} />
    </AdminMainContainer>
  )
}
